import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KendoAllModule } from './kendo-all.module';
import { PafAllDirectivesModule } from './paf-all-directives.module';
import { PafAllValidatorsModule } from './paf-all-validators.module';

import { IconsModule, IconModule } from '@progress/kendo-angular-icons';

import { PafAllPipesModule } from './paf-all-pipes.module';


import {
  AccidentologieComponent,
  AgencyRowComponent,
  BtnDeleteSupplierComponent,
  ContactRowComponent,
  DebugToolbarComponent,
  DepartmentsComponent,
  DocHistoButtonComponent,
  DuplicateSupplierModalComponent,
  HistoryButtonComponent,
  InfosDematComponent,
  LangSelectorComponent,
  NumTiersComponent,
  QuestionRowComponent,
  PafRoundProgressSvgComponent,
  RoundedProgressBarComponent,
  SpinnerComponent,
  SpinnerOverlayComponent,
  SuppContactRowComponent,
  SupplierDocRowComponent,
  SupplierQualDocRowComponent,
  SupplierStatutBadgeComponent,
  SupplierValidationToolbarComponent,
  SupplierWorkflowComponent,
  ValidationErrorsComponent,
  WindowLockerComponent,
  PafLabelComponent,
  SupplierAccountInfoComponent,
  SupplierDescriptifComponent,
  SupplierDetailsComponent,
  SupplierKnowledgeComponent,
  SupplierQualityDocsComponent,
  SupplierRecapComponent,
  SupplierRegulDocsComponent,
  SupplierRSEComponent,
  SupplierRseAnswerComponent,
  SupplierRseAnswerIdxComponent,
  SupplierRseQstGroupComponent,
  SwitcheryIosAdapterComponent,
  PafComboBoxComponent
} from '../all-components';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KendoAllModule,
    PafAllDirectivesModule,
    PafAllValidatorsModule,
    PafAllPipesModule,
    DecimalPipe,
    IconsModule,
    IconModule
  ],
  declarations: [
    AccidentologieComponent,
    AgencyRowComponent,
    BtnDeleteSupplierComponent,
    ContactRowComponent,
    DebugToolbarComponent,
    DepartmentsComponent,
    DocHistoButtonComponent,
    DuplicateSupplierModalComponent,
    HistoryButtonComponent,
    InfosDematComponent,
    LangSelectorComponent,
    NumTiersComponent,
    QuestionRowComponent,
    PafRoundProgressSvgComponent,
    RoundedProgressBarComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    SuppContactRowComponent,
    SupplierDocRowComponent,
    SupplierQualDocRowComponent,
    SupplierStatutBadgeComponent,
    SupplierValidationToolbarComponent,
    SupplierWorkflowComponent,
    ValidationErrorsComponent,
    WindowLockerComponent,
    PafLabelComponent,
    SupplierAccountInfoComponent,
    SupplierDescriptifComponent,
    SupplierDetailsComponent,
    SupplierKnowledgeComponent,
    SupplierQualityDocsComponent,
    SupplierRecapComponent,
    SupplierRegulDocsComponent,
    SupplierRSEComponent,
    SupplierRseAnswerComponent,
    SupplierRseAnswerIdxComponent,
    SupplierRseQstGroupComponent,
    SwitcheryIosAdapterComponent,
    PafComboBoxComponent
    ]
  , exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PafAllDirectivesModule,
    PafAllValidatorsModule,
    AccidentologieComponent,
    AgencyRowComponent,
    BtnDeleteSupplierComponent,
    ContactRowComponent,
    DebugToolbarComponent,
    DepartmentsComponent,
    DocHistoButtonComponent,
    DuplicateSupplierModalComponent,
    HistoryButtonComponent,
    InfosDematComponent,
    LangSelectorComponent,
    NumTiersComponent,
    QuestionRowComponent,
    PafRoundProgressSvgComponent,
    RoundedProgressBarComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    SuppContactRowComponent,
    SupplierDocRowComponent,
    SupplierQualDocRowComponent,
    SupplierStatutBadgeComponent,
    SupplierValidationToolbarComponent,
    SupplierWorkflowComponent,
    ValidationErrorsComponent,
    WindowLockerComponent,
    PafLabelComponent,
    SupplierAccountInfoComponent,
    SupplierDescriptifComponent,
    SupplierDetailsComponent,
    SupplierKnowledgeComponent,
    SupplierQualityDocsComponent,
    SupplierRecapComponent,
    SupplierRegulDocsComponent,
    SupplierRSEComponent,
    SupplierRseAnswerComponent,
    SupplierRseAnswerIdxComponent,
    SupplierRseQstGroupComponent,
    DecimalPipe,
    SwitcheryIosAdapterComponent,
    PafComboBoxComponent
  ]
})
export class PafAllComponentsModule { }
